import { gateway } from "../../../gateway";
import { IEventDeliveryLogDetail } from "../interfaces";

export const getEventDeliveryLogDetail = async (logUid: string): Promise<IEventDeliveryLogDetail> => {
  const response = await gateway.get(`/event-delivery/logs/${logUid}`);
  return response?.data?.data;
};
